export default __webpack_public_path__ + "static/media/Tumblr.c796acda.svg";